import { message, Space } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../components/action-bar";
import ActionButton from "../../../components/action-button";
import MiniTable from "../../../components/mini-table";
import { Alerta } from "../../../constants";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import useLoading from "../../../hooks/useLoading";
import {
  fetchDocumentos,
  isEditableSelector,
  documentosAlertaNivelSelector,
  documentosAlertasSelector,
  documentosSearchSelector,
  documentosSelector,
  fetchVerificarLimite,
} from "../../../store/empresa";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import { openPopup } from "../../../util/window";
import Alertas from "../_Alertas";
import styles from "../_styles.less";
import EmpresaDocumentosTable from "./_table";
import useModulo from "../../../hooks/useModulo";

export default function EmpresaDocumentosDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const nivel = useSelector(documentosAlertaNivelSelector);
  const isEditable = useSelector(isEditableSelector);
  const documentos = useSelector(documentosSelector);
  const search = useSelector(documentosSearchSelector);
  const alertas = useSelector(documentosAlertasSelector);
  const loading = useLoading(fetchDocumentos.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const isNA =
    nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleSearch = (search) => {
    dispatch(fetchDocumentos({ empresaId, search }));
  };

  const handleCreate = () => {

    unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
    .then(() => {
    history.replace(
      `${moduloBasePath}/empresas/${empresaId}/documentos/create`
    );
    })
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(
      axios.delete(`/empresas/${empresaId}/documentos`, {
        params: { ids: selectedIds },
      })
    )
      .then(() => {
        message.success(t("Registro(s) removido(s) com sucesso"));
        setSelectedIds([]);
        dispatch(fetchDocumentos({ empresaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = (documento) => {
    history.replace(
      `${moduloBasePath}/empresas/${empresaId}/documentos/${documento.id}`
    );
  };

  const handleLogs = () => {
    openPopup(
      `/logs?categoria=/empresas/${empresaId}/documentos/`,
      `logs_/empresas/${empresaId}/documentos/`
    );
  };

  const actions = [];
  if (isEditable) {
    actions.push(
      <ActionButton.Create disabled={isNA} onClick={handleCreate} />
    );
    actions.push(
      <ActionButton.Remove
        disabled={selectedIds.length === 0 || isNA}
        onClick={handleRemove}
        loading={loadingRemove}
      />
    );
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs} />);
  actions.push(
    <MiniTable.DownloadButton
      disabled={loading || documentos.length === 0}
      miniTableRef={miniTableRef}
    />
  );
  const title = () => (
    <ActionBar search={search} onSearch={handleSearch}>
      {actions}
    </ActionBar>
  );
  return (
    <Space direction="vertical" className={styles["space-2"]}>
      <EmpresaDocumentosTable
        dataSource={documentos}
        loading={loading}
        miniTableRef={miniTableRef}
        onClick={handleDetail}
        onSelectedIdsChange={setSelectedIds}
        selectedIds={selectedIds}
        title={title}
      />
      <Alertas alertas={alertas} />
    </Space>
  );
}

EmpresaDocumentosDetailPage.propTypes = {
  documentos: PropTypes.array,
  onCreate: PropTypes.func,
  onRemove: PropTypes.func,
};
